import type { Assistant } from "@inrev/assistant";
import type { AssistantConversationId } from "@inrev/common";
import { useFetchAssistantChartImage } from "@portal/api/assistant/admin";
import { Text } from "@portal/components/primitives";
import { AdminAssistantStoredChart } from "../AdminAssistantStoredChart";

export const AdminAssistantImageChart = ({
	chart,
	conversationId,
}: {
	chart: Assistant.Charts.ImageChart;
	conversationId: AssistantConversationId;
}) => {
	const image = useFetchAssistantChartImage(conversationId, chart.imageId);

	return (
		<AdminAssistantStoredChart query={{ ...image, data: image.url }} resource="chart">
			{(url) => (
				<div className="flex flex-col gap-1" data-testid="assistant-image-chart">
					{chart.title === undefined ? null : (
						<Text type="body-strong" color="primary">
							{chart.title}
						</Text>
					)}
					<img src={url} alt={chart.title ?? "Chart drawn by the assistant"} className="w-full" />
					<Text type="caption" color="tertiary">
						Drawn by the assistant from figures it copied out of its tool results.
					</Text>
				</div>
			)}
		</AdminAssistantStoredChart>
	);
};
